import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DashboardsDisplayGridRowDataFragmentGql } from './DashboardsDisplayGridRowFragmentGql';

export const FlowDownstreamDashboardsFilteredByFlowOutputFieldQueryGql: DocumentNode = gql`
query FlowDownstreamDashboardsFilteredByFlowOutputFieldQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: DashboardSortOrder!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFieldsConnection(filter: { id: $selectedFlowOutputFieldId }) {
      nodes {
        downstreamDashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DashboardsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${DashboardsDisplayGridRowDataFragmentGql}
`;
